import type {
  E_FloatingWidgetMessageLocation,
  E_FloatingWidgetTriggerLocation,
  E_FloatingWidgetMobileMessageLocation,
} from './FloatingWidgetTrigger';

export interface I_Widget {
  mount(querySelector: string, config: I_WidgetConfig): void;
  unmount(): void;
}

export interface I_WidgetCustomer {
  email?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
}

export interface I_WidgetTheme {
  brandColor?: string;
  headingColor?: string;
  bodyColor?: string;
  primaryButton?: {
    backgroundColor?: string;
    textColor?: string;
  };
  secondaryButton?: {
    backgroundColor?: string;
    textColor?: string;
  };
  floatingButton?: {
    label?: string;
    backgroundColor?: string;
    textColor?: string;
    iconColor?: string;
  };
  floatingButtonMessage?: {
    backgroundColor?: string;
    textColor?: string;
  };
}

export interface I_WidgetConfig {
  widgetLocation?: E_FloatingWidgetTriggerLocation;
  mobileMessageLocation?: E_FloatingWidgetMobileMessageLocation;
  messageLocation?: E_FloatingWidgetMessageLocation;
  platform?: E_WidgetPlatform;
  customer?: I_WidgetCustomer;
  storefrontLoginURL: string;
  theme?: I_WidgetTheme;
  appName?: string;
  /**
   * CSS selector(s) for the "Buy Now" button(s) on the page.
   *
   * When provided, the widget will intercept clicks on matching elements and redirect the
   * customer through the standard cart checkout instead of the platform's accelerated checkout.
   * This allows loyalty discount codes to be applied before checkout begins.
   *
   * Leave empty (or omit) to disable the interception entirely.
   *
   * Example: `"button[name=\"checkout\"], .shopify-payment-button__button"`
   */
  buyNowButtonSelector?: string;
  showNationality?: boolean;
  /** When true, customers must redeem their entire points balance — no partial amounts. */
  fullRedemptionOnly?: boolean;
  /** Set to false to hide the rotating pop-up messages next to the floating button. Defaults to true. */
  showMessages?: boolean;
}

export interface I_BaseWidgetProps {
  isWidgetOpen: boolean;
  openWidget: () => void;
}

export enum E_WidgetPlatform {
  SHOPIFY = 'Shopify',
}

export type T_WidgetConfigContext = {
  widgetLocation: E_FloatingWidgetTriggerLocation;
  mobileMessageLocation: E_FloatingWidgetMobileMessageLocation;
  messageLocation: E_FloatingWidgetMessageLocation;
  countryCode: string;
  phoneNumber: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  isRegistered: boolean;
  storefrontLoginURL?: string;
  theme?: I_WidgetTheme;
  appName: string;
  showNationality?: boolean;
  fullRedemptionOnly: boolean;
  showMessages: boolean;
};
